import React from 'react';
import { FormattedMessage } from 'react-intl';
import config from 'appconfig';
import { StyledLink } from '../StyledComponents';
import { StyledPipe } from './StyledPipe';

export const DownloadLink = ({
  downloadUrl,
  productKey,
  description,
}: {
  downloadUrl: string;
  productKey: string;
  description: string;
}) => {
  let productKeyWithoutPricingPlanPrefix = productKey;
  if (productKey?.split('.')[0] === 'pricingplan') {
    productKeyWithoutPricingPlanPrefix = productKey.split('.').slice(1).join('.');
  }
  return (
    <>
      {/* Add Analytics here; analyticsKey = productPackage.isAddOn() ? "download-add-on-link" : "download-product-link" */}
      <StyledLink
        href={
          downloadUrl || `${config.marketplaceUrl}/plugins/${productKeyWithoutPricingPlanPrefix}`
        }
        data-cy="actions-section-download-button"
      >
        <FormattedMessage id="mac.licenses.download" defaultMessage="Download" />
        {downloadUrl && ` ${description}`}
      </StyledLink>
      <StyledPipe />
    </>
  );
};
